// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.lt-count-panel__label-chip {
  margin: 10px 18px 0;
  display: inline-flex;
  align-items: center;
  padding: 4px 10px;
  border-radius: 999px;
  font-size: 0.78rem;
  font-weight: 700;
  background: color-mix(in srgb, var(--lt-brand, #0877bc) 22%, transparent);
  color: #e2e8f0;
}

.lt-count-panel__value {
  grid-area: clock;
  align-self: center;
  font-variant-numeric: tabular-nums;
  font-family: ui-monospace, SFMono-Regular, Menlo, Monaco, Consolas, monospace;
  font-size: 1.6rem;
  font-weight: 800;
  letter-spacing: 0.02em;
  color: #f8fafc;
  min-width: 2.5rem;
  text-align: right;
}

.lt-count-panel__row--dirty {
  border-color: color-mix(in srgb, #fbbf24 45%, transparent);
}

.lt-count-panel__btn--bump {
  background: rgba(255, 255, 255, 0.1);
  color: #e2e8f0;
  padding: 8px 10px;
}

.lt-count-panel__btn--plus5 {
  background: rgba(255, 255, 255, 0.12);
  color: #e2e8f0;
}

.lt-count-panel__btn--save:disabled {
  opacity: 0.4;
}
`, "",{"version":3,"sources":["webpack://./src/pages/LiveTraining/LiveTrainingCoachCountPanel.css"],"names":[],"mappings":"AAAA;EACE,mBAAmB;EACnB,oBAAoB;EACpB,mBAAmB;EACnB,iBAAiB;EACjB,oBAAoB;EACpB,kBAAkB;EAClB,gBAAgB;EAChB,yEAAyE;EACzE,cAAc;AAChB;;AAEA;EACE,gBAAgB;EAChB,kBAAkB;EAClB,kCAAkC;EAClC,6EAA6E;EAC7E,iBAAiB;EACjB,gBAAgB;EAChB,sBAAsB;EACtB,cAAc;EACd,iBAAiB;EACjB,iBAAiB;AACnB;;AAEA;EACE,0DAA0D;AAC5D;;AAEA;EACE,oCAAoC;EACpC,cAAc;EACd,iBAAiB;AACnB;;AAEA;EACE,qCAAqC;EACrC,cAAc;AAChB;;AAEA;EACE,YAAY;AACd","sourcesContent":[".lt-count-panel__label-chip {\n  margin: 10px 18px 0;\n  display: inline-flex;\n  align-items: center;\n  padding: 4px 10px;\n  border-radius: 999px;\n  font-size: 0.78rem;\n  font-weight: 700;\n  background: color-mix(in srgb, var(--lt-brand, #0877bc) 22%, transparent);\n  color: #e2e8f0;\n}\n\n.lt-count-panel__value {\n  grid-area: clock;\n  align-self: center;\n  font-variant-numeric: tabular-nums;\n  font-family: ui-monospace, SFMono-Regular, Menlo, Monaco, Consolas, monospace;\n  font-size: 1.6rem;\n  font-weight: 800;\n  letter-spacing: 0.02em;\n  color: #f8fafc;\n  min-width: 2.5rem;\n  text-align: right;\n}\n\n.lt-count-panel__row--dirty {\n  border-color: color-mix(in srgb, #fbbf24 45%, transparent);\n}\n\n.lt-count-panel__btn--bump {\n  background: rgba(255, 255, 255, 0.1);\n  color: #e2e8f0;\n  padding: 8px 10px;\n}\n\n.lt-count-panel__btn--plus5 {\n  background: rgba(255, 255, 255, 0.12);\n  color: #e2e8f0;\n}\n\n.lt-count-panel__btn--save:disabled {\n  opacity: 0.4;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
